import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts the filename from a Response's Content-Disposition header.
 * Handles both `filename` and `filename*=UTF-8''...` (RFC 5987) forms.
 * Returns the fallback if no filename is found.
 */
export function parseFilenameFromResponse(response: Response, fallback: string): string {
  const contentDisposition = response.headers.get("Content-Disposition");
  if (!contentDisposition) return fallback;
  const match = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;'"\n]+)/i);
  return match ? decodeURIComponent(match[1].trim()) : fallback;
}
